import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { T } from '@sm/intl';
import { Chip } from '@wds/chip';
import { Typography } from '@wds/typography';
import { createUseStyles } from 'react-jss';
import { Box } from '@wds/box';
import { useThemesReuse, useThemesReuseActions } from '../../../Context';
export const COPY = {
  themesAddedHeader: {
    id: 'OpenEndedCoding.AddThemeModalColdStart.themesAddedHeader',
    defaultMessage: 'Themes to be added',
    description: '[Type: Header][Vis: med] - Create Theme Modal themes added'
  }
};
const useStyles = createUseStyles(theme => ({
  badges: {
    display: 'inline-flex',
    flexWrap: 'wrap'
  }
}));
const SelectedThemes = () => {
  const classes = useStyles();
  const {
    selectedReusedThemes
  } = useThemesReuse();
  const {
    removeReusedTheme,
    addPreviouslyUsedTheme
  } = useThemesReuseActions();
  if (selectedReusedThemes.length === 0) {
    return _jsx(_Fragment, {});
  }
  const handleRemoveTheme = themeToRemove => {
    removeReusedTheme(themeToRemove);
    if (themeToRemove.suggested) {
      addPreviouslyUsedTheme(themeToRemove.name);
    }
  };
  return _jsxs(_Fragment, {
    children: [_jsx(Box, {
      mb: 2,
      children: _jsx(Typography, {
        variant: "body",
        weight: "medium",
        children: _jsx(T, {
          desc: COPY.themesAddedHeader
        })
      })
    }), _jsx(Box, {
      mb: 2,
      className: classes.badges,
      children: selectedReusedThemes.map(s => _jsx(Box, {
        mr: 2,
        mb: 2,
        children: _jsx(Chip, {
          onClick: () => handleRemoveTheme(s),
          children: s.name
        })
      }, `selected-theme-${s}`))
    })]
  });
};
export default SelectedThemes;